import type {
  IDeleteUserPayload,
  ISearchUsersParams,
  ISearchUsersResponse,
  IUpdateEmailPayload,
  IUpdatePasswordPayload,
  IUpdateUserPayload,
  IUserPreferences,
  IUserProfile,
} from "../types/user";
import type { ApiClient } from "./client";

export class UserApi {
  constructor(private apiClient: ApiClient) {}

  async getUser(): Promise<IUserProfile | null> {
    const response = await this.apiClient.get<IUserProfile | null>("/user/me");
    return response.data;
  }

  async updateUser(data: IUpdateUserPayload): Promise<IUserProfile> {
    const response = await this.apiClient.put<IUserProfile>(
      "/user/update-user",
      data,
    );
    return response.data;
  }

  async updateEmail(data: IUpdateEmailPayload): Promise<void> {
    await this.apiClient.post("/user/update-email", data);
  }

  async updatePassword(data: IUpdatePasswordPayload): Promise<void> {
    await this.apiClient.post("/user/update-password", data);
  }

  async completeTour(): Promise<void> {
    await this.apiClient.patch("/user/complete-tour");
  }

  async completeCaTour(): Promise<void> {
    await this.apiClient.patch("/user/complete-ca-tour");
  }

  async deleteAccount(data: IDeleteUserPayload): Promise<void> {
    await this.apiClient.post("/user/delete-account", data);
  }

  async deleteUserRequest(): Promise<void> {
    await this.apiClient.delete("/user/delete-request");
  }

  async getUserPreferences(): Promise<IUserPreferences> {
    const response =
      await this.apiClient.get<IUserPreferences>("/user/preferences");
    return response.data;
  }

  async updateUserPreferences(
    data: IUserPreferences,
  ): Promise<IUserPreferences> {
    const response = await this.apiClient.patch<IUserPreferences>(
      "/user/preferences",
      data,
    );
    return response.data;
  }

  async searchUsers(params: ISearchUsersParams): Promise<ISearchUsersResponse> {
    const response = await this.apiClient.get<ISearchUsersResponse>(
      "/user/search",
      {
        params: {
          query: params.query,
          limit: params.limit,
        },
      },
    );

    return response.data;
  }
}
